import { Deserializable } from '../_common/deserializable';

export class PayoutRecord implements Deserializable {
      id: number;
      source: number;
      country: string;
      mtMonth: number;
      payoutMonth: number;
      account: string;
      operator: string;
      shortCode: string;
      keyword: string;
      price: number;
      supposeMt: number;
      payoutMt: number;
      refund: number;
      createdAt: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
